import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { preserveTrialData } from "@/utils/trialUtils";

export const useUpgradeHandler = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleUpgrade = async (plan: string) => {
    try {
      // Preserve trial data before upgrade
      const preservedData = await preserveTrialData();
      
      if (preservedData) {
        // Store preserved data temporarily for the subscription process
        sessionStorage.setItem('preserved_trial_data', JSON.stringify(preservedData));
      }

      // Navigate to subscription form with plan and preserved data flag
      navigate(`/subscription-form?plan=${plan}&preserve_data=true`);
      
    } catch (error) {
      console.error('Error during upgrade initiation:', error);
      toast({
        title: "Upgrade Error",
        description: "There was an error initiating the upgrade. Please try again.",
        variant: "destructive",
      });
    }
  };

  return { handleUpgrade };
};